var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit ? '编辑':'新建') + "职位"),
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-col",
    staticStyle: {
      "margin-left": "-35px"
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "140px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作地点",
      "prop": "cityIds"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.cityIds),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cityIds", $$v)
      },
      expression: "ruleForm.cityIds"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地点",
      "prop": "workPlace"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.workPlace),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "workPlace", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.workPlace"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位序列",
      "prop": "sequenceMain",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.ruleForm.sequenceSub = ''
      }
    },
    model: {
      value: (_vm.ruleForm.sequenceMain),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sequenceMain", $$v)
      },
      expression: "ruleForm.sequenceMain"
    }
  }, _vm._l((_vm.mainSeqList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位子序列",
      "prop": "sequenceSub",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.sequenceSub),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sequenceSub", $$v)
      },
      expression: "ruleForm.sequenceSub"
    }
  }, _vm._l((_vm.subSeqList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘部门",
      "prop": "deptCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "clearable": true,
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.ruleForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptCode", $$v)
      },
      expression: "ruleForm.deptCode"
    }
  }, _vm._l((_vm.deptArr), function(item, index) {
    return _c('el-option', {
      key: item.deptCode,
      attrs: {
        "label": item.name,
        "value": item.deptCode
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.needIds.includes(_vm.projectId)) ? _c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "prop": "scoreType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.scoreType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "scoreType", $$v)
      },
      expression: "ruleForm.scoreType"
    }
  }, _vm._l((_vm.scoreTypeList), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘人数",
      "prop": "recruitCount"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 5,
      "placeholder": "请输入（0或者不填表示不限）"
    },
    model: {
      value: (_vm.ruleForm.recruitCount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "recruitCount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.recruitCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.isEdit,
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.state),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "state", $$v)
      },
      expression: "ruleForm.state"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_STATE), function(state, key) {
    return (_vm.checkStateOption(state)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": state.text,
        "value": state.value
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘范围",
      "prop": "property"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.property),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "property", $$v)
      },
      expression: "ruleForm.property"
    }
  }, _vm._l((_vm.selectMap.WB_PROPERTY_TYPE), function(state, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": state.text,
        "value": state.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否门户展示",
      "prop": "showInDesk"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.showInDesk),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "showInDesk", $$v)
      },
      expression: "ruleForm.showInDesk"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), (_vm.hasSalary) ? _c('el-form-item', {
    attrs: {
      "label": "定薪规则",
      "prop": "paymentId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.paymentId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "paymentId", $$v)
      },
      expression: "ruleForm.paymentId"
    }
  }, _vm._l((_vm.paymentRuleList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.name,
        "value": item.id + ''
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否推送供应商",
      "prop": "toSupplier"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.toSupplier),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "toSupplier", $$v)
      },
      expression: "ruleForm.toSupplier"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内推职位",
      "prop": "recommendable"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.recommendable),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "recommendable", $$v)
      },
      expression: "ruleForm.recommendable"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘HR",
      "prop": "mark"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.mark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mark"
    }
  })], 1), _vm._v(" "), (String(_vm.ruleForm.toSupplier) === '1') ? _c('el-form-item', {
    attrs: {
      "label": "供应商选择",
      "prop": "linkmanAndSupplier",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.ruleForm.linkmanAndSupplier,
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择",
      "no-data-text": _vm.filterEmpty ? '无匹配数据' : '无数据',
      "clearable": true,
      "filter-method": _vm.selectFilter,
      "popper-class": "supplier-select-popover"
    },
    on: {
      "input": _vm.handleOptionChange
    }
  }, [(!_vm.filterEmpty) ? _vm._l((_vm.suppliers), function(supplier) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (supplier.users.length),
        expression: "supplier.users.length"
      }],
      key: supplier.compId
    }, [(supplier.users.filter(function (u) { return u.visible; }).length) ? _c('el-option', {
      staticClass: "supplier-checkbox",
      attrs: {
        "label": supplier.compName,
        "value": supplier.compId
      }
    }, [_vm._v("\n                                " + _vm._s('所属公司：' + supplier.compName) + "\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((supplier.users), function(item) {
      return _c('el-option', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.visible),
          expression: "item.visible"
        }],
        key: item.id,
        attrs: {
          "label": item.name,
          "disabled": _vm.ruleForm.linkmanAndSupplier.includes(supplier.compId),
          "value": String(item.id)
        }
      }, [_c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right",
          "color": "#8492a6",
          "margin-right": "25px"
        }
      }, [_vm._v(_vm._s(item.company))])])
    })], 2)
  }) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width-longer",
    attrs: {
      "label": "在线时间:",
      "prop": "onlineDate"
    }
  }, [_c('div', {
    staticClass: "f-edit"
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "date",
      "placeholder": "上线时间",
      "editable": false,
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.onlineDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "onlineDate", $$v)
      },
      expression: "ruleForm.onlineDate"
    }
  }), _vm._v("\n                至\n                "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "prop": "offlineDate"
    }
  }, [_c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "date",
      "placeholder": "下线时间",
      "editable": false,
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.offlineDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "offlineDate", $$v)
      },
      expression: "ruleForm.offlineDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作性质",
      "prop": "workType",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.workType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "workType", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.workType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.advise),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "advise", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.advise"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#b1b1b1",
      "font-size": "12px",
      "line-height": "24px"
    }
  }, [_vm._v("若存在多个方向，请用顿号‘、’隔开，例如：‘开发、设计、测试’，若不填写，则面试官填写面试评价时无须选择")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.description),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "description", $$v)
      },
      expression: "ruleForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位要求",
      "prop": "requirement"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.requirement),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "requirement", $$v)
      },
      expression: "ruleForm.requirement"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并继续添加")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-827b1898"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addPositionDialog.vue
// module id = null
// module chunks = 